import React, {ForwardRefRenderFunction, forwardRef, useState} from 'react';

import {Input} from './styles';

interface Props {
  value?: string;
  handleConfirm: (text: string) => void;
}

const TextFilter: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  {value, handleConfirm},
  ref,
) => {
  const [text, setText] = useState(value ?? '');

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleConfirm(text);
  };

  const onBlur = () => handleConfirm(text);

  return (
    <Input
      {...{
        onKeyDown,
        onBlur,
        autoFocus: !value,
        ref,
        onChange: (e) => setText(e.target.value),
        value: text,
      }}
    />
  );
};

export default forwardRef(TextFilter);
